export default __webpack_public_path__ + "static/media/flag-bhutan.4fd7e311.svg";